<template>
    <v-container fluid>
        <v-btn
            :loading="brokers === null"
            @click="newBroker"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Brokers ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <v-btn
                    @click="showReportForm = !showReportForm"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="brokers === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="broker.id"
                    cols="12"
                    v-for="broker in brokers"
                >
                    <v-card
                        class="broker-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                    >
                        <v-card-title
                            @click="loadBrokerForm(broker.id)"
                            style="cursor: pointer"
                        >
                            <h5>#{{ broker.id }}</h5>
                        </v-card-title>
                        <v-card-subtitle
                            @click="loadBrokerForm(broker.id)"
                            style="cursor: pointer"
                        >
                            {{ broker.name }}
                        </v-card-subtitle>
                        <v-card-text>
                            <!--<v-chip
                                class="ma-1"
                                color="warning"
                                dark
                                small
                                v-show="broker.isLateRegistrationSuspended == true"
                            >Late Registration Suspended</v-chip>-->
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="brokerFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeBrokerForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Broker Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row
                        align="center"
                        justify="center"
                        v-if="true"
                    >
                        <BrokerForm
                            :broker-id="brokerFormBrokerId"
                            :key="brokerFormKey"
                            @close="closeBrokerForm"
                            @deleted="deleteBroker"
                            @saved="updateBroker"
                        />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>
        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showReportForm"
            width="350px"
        >
            <AccisureBrokerComissionReportForm @close="showReportForm = false" />
        </v-dialog>
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
import uuid4 from "../helpers/uuid4";
import BrokerForm from "../components/forms/BrokerForm";
import AccisureBrokerComissionReportForm from "../components/forms/AccisureBrokerComissionReportForm";

export default {
    name: "Brokers",
    props: [],

    data: function() {
        return {
            //main data
            brokers: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form data
            brokerFormVisible: false,
            brokerFormKey: 0,
            brokerFormBrokerId: 0, //new Broker(),

            showReportForm: false

        };
    },
    mounted: function() {
        this.getBrokers();
        //
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        BrokerForm,
        AccisureBrokerComissionReportForm
        //
    },
    methods: {
        getBrokers() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("brokers/get", {
                    requestId: requestId
                })
                .then(brokersResponse => {
                    if (this.requestId == brokersResponse.requestId) {
                        this.brokers = brokersResponse.data.page;
                        this.totalMatches = brokersResponse.data.total;
                        this.pageSize = brokersResponse.data.pageSize;
                        this.pageNo = brokersResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            brokersResponse.data.total / this.pageSize
                        );
                    }
                    if (this.pageNo > this.pagesCount)
                        this.pageNo = this.pagesCount;
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.brokers !== null) this.brokers = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getBrokers,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        newBroker() {
            this.loadBrokerForm(0);
        },
        loadBrokerForm(brokerId) {
            this.brokerFormBrokerId = brokerId;
            this.brokerFormKey = brokerId;
            this.brokerFormVisible = true;
        },
        closeBrokerForm() {
            this.brokerFormVisible = false;
            this.brokerFormKey = null;
        },
        updateBroker() {
            this.paginationDebounce(0, true);
        },
        deleteBroker() {
            this.paginationDebounce(0, true);
        },
    }
};
</script>

<style lang="stylus" scoped>
.broker-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.theme--dark {
    .patient-panel {
        .v-card {
            background-color: rgba(127, 127, 127, 0.1);
        }
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
